import { Link } from "react-router-dom";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import { useEffect, useState } from "react";
import { NewSideBarAdmin } from "../../NewSideBarAdmin";
import Sidebare from "../Sidbare/Sidebare";
import "./Afficheproduit.css";

const AfficheProduit: React.FC<ArticleInfo> = ({
  IdArticle,
  Designation,
  PrixVenteArticleTTC,
  Marque,
  Description,
  urlImage,
  stock,
  RefArticle,
  LibelleSubstitut,
  QantityMagasin,
  prix_ht_1_magasin,
  PrixNetHT,
  prix_ht_3_magasin,
  prix_ttc,
  Qte,
  DesignationAr,
  Remise,
  loading,
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 450);
  const [autoDescription, setAutoDescription] = useState<string>("");
  const [descLoading, setDescLoading] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<"info" | "desc" | "stock">("info");

  const handleGoBack = () => window.history.back();

  /* ── Responsive ───────────────────────────────────── */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 450);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ── Auto description ─────────────── */
  useEffect(() => {
    if (!RefArticle && !Designation) return;

const generateDescription = () => {
  const productName = Designation || "Cette pièce";
  const reference = RefArticle || "Non spécifiée";

  const generated = `${productName} est une solution fiable conçue pour répondre aux standards professionnels du secteur automobile et industriel. Elle assure performance, longévité et compatibilité optimale avec vos équipements. Référence : ${reference}${Marque ? ` | Marque : ${Marque}` : ""}. Un choix idéal pour garantir efficacité et sécurité.`;

  setAutoDescription(generated);
};

    generateDescription();
  }, [RefArticle, Designation]);

  /* ── Stock badge ──────────────────────────────────── */
  let actualStock = stock;
  if (!stock || Number(stock) === 0) {
    if (Qte && Number(Qte) !== 0) {
      actualStock = Qte;
    } else if (QantityMagasin && Number(QantityMagasin) !== 0) {
      actualStock = QantityMagasin;
    } else {
      actualStock = stock ?? Qte ?? QantityMagasin ?? 0;
    }
  }
  const stockNum = Number(actualStock);
  const stockStatus =
    isNaN(stockNum) || stockNum === 0
      ? "rupture"
      : stockNum < 10
      ? "faible"
      : "disponible";

  const stockLabel: Record<string, string> = {
    rupture: "Rupture de stock",
    faible: "Stock faible",
    disponible: "En stock",
  };

  /* ══════════════════════════════════════════════════
     LOADER
  ══════════════════════════════════════════════════ */
  const Loader = ({ compact = false }) => (
    <div className={`d-p-admin-upg-loader ${compact ? "d-p-admin-upg-loader-compact" : ""}`}>
      <div className="d-p-admin-upg-spinner" />
      <span className="d-p-admin-upg-loader-text">Chargement…</span>
    </div>
  );

  /* ══════════════════════════════════════════════════
     MOBILE VIEW
  ══════════════════════════════════════════════════ */
  const MobileView = () => (
    <div className="d-p-admin-upg-mobile">

      {/* Hero image */}
      <div className="d-p-admin-upg-mobile-hero">
        <button className="d-p-admin-upg-mobile-back" onClick={handleGoBack}>
          <i className="bi bi-arrow-left-short" />
        </button>
        <img
          src={urlImage}
          alt={Designation}
          className="d-p-admin-upg-mobile-img"
        />
        <div className="d-p-admin-upg-mobile-img-fade" />

        {/* Stock badge on image */}
        <span className={`d-p-admin-upg-stock-badge d-p-admin-upg-stock-${stockStatus}`}>
          <span className="d-p-admin-upg-stock-dot" />
          {stockLabel[stockStatus]}
        </span>
      </div>

      {/* Content card */}
      <div className="d-p-admin-upg-mobile-body">

        {/* Title */}
        <h2 className="d-p-admin-upg-mobile-name">
          {Designation}
          {DesignationAr && <span className="d-p-admin-upg-mobile-name-ar"> · {DesignationAr}</span>}
        </h2>

        {/* Ref + price row */}
        <div className="d-p-admin-upg-mobile-meta">
          <span className="d-p-admin-upg-ref-badge">
            <i className="bi bi-upc" /> {RefArticle}
          </span>
          <span className="d-p-admin-upg-price-mobile">{PrixNetHT} <small>MAD</small></span>
        </div>

        {/* Category pill */}
        {Marque && (
          <span className="d-p-admin-upg-cat-pill">
            <i className="bi bi-grid-fill" /> {Marque}
          </span>
        )}

        {/* Rating */}
        <div className="d-p-admin-upg-rating">
          {[1,2,3,4,5].map((s) => (
            <i key={s} className={`bi bi-star${s <= 4 ? "-fill" : ""} d-p-admin-upg-star`} />
          ))}
          <span className="d-p-admin-upg-rating-label">4.0 <span>(45 avis)</span></span>
        </div>

        {/* Tabs */}
        <div className="d-p-admin-upg-tabs">
          {(["info", "desc", "stock"] as const).map((tab) => (
            <button
              key={tab}
              className={`d-p-admin-upg-tab ${activeTab === tab ? "d-p-admin-upg-tab-active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === "info" ? "Infos" : tab === "desc" ? "Description" : "Stock"}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div className="d-p-admin-upg-tab-content">
          {activeTab === "info" && (
            <div className="d-p-admin-upg-info-grid">
              <div className="d-p-admin-upg-info-item">
                <span className="d-p-admin-upg-info-label">Référence</span>
                <span className="d-p-admin-upg-info-value">{RefArticle}</span>
              </div>
              <div className="d-p-admin-upg-info-item">
                <span className="d-p-admin-upg-info-label">Prix TTC</span>
                <span className="d-p-admin-upg-info-value">{PrixNetHT} MAD</span>
              </div>
              <div className="d-p-admin-upg-info-item">
                <span className="d-p-admin-upg-info-label">Remise</span>
                <span className="d-p-admin-upg-info-value">{Remise ?? "0"} %</span>
              </div>
              <div className="d-p-admin-upg-info-item">
                <span className="d-p-admin-upg-info-label">Substitut</span>
                <span className="d-p-admin-upg-info-value">
                  {Array.isArray(LibelleSubstitut) && LibelleSubstitut[0]?.trim()
                    ? LibelleSubstitut.join(", ")
                    : "N/A"}
                </span>
              </div>
            </div>
          )}

          {activeTab === "desc" && (
            <div className="d-p-admin-upg-desc-block">
              {descLoading ? (
                <div className="d-p-admin-upg-desc-loading">
                  <div className="d-p-admin-upg-desc-spinner" />
                  <span>Génération de la description…</span>
                </div>
              ) : (
                <>
                  <div className="d-p-admin-upg-desc-badge">
                    <i className="bi bi-stars" />
                  </div>
                  <p className="d-p-admin-upg-desc-text">
                    {autoDescription || Description || "Aucune description disponible."}
                  </p>
                </>
              )}
            </div>
          )}

          {activeTab === "stock" && (
            <div className="d-p-admin-upg-stock-block">
              <div className={`d-p-admin-upg-stock-big d-p-admin-upg-stock-${stockStatus}`}>
                <i className={`bi bi-${stockStatus === "disponible" ? "check-circle-fill" : stockStatus === "faible" ? "exclamation-circle-fill" : "x-circle-fill"}`} />
                <div>
                  <span className="d-p-admin-upg-stock-qty">{actualStock} unités</span>
                  <span className="d-p-admin-upg-stock-label-text">{stockLabel[stockStatus]}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  /* ══════════════════════════════════════════════════
     DESKTOP VIEW
  ══════════════════════════════════════════════════ */
  const DesktopView = () => (
    <div className="d-p-admin-upg-desktop">

      {/* Top bar */}
      <div className="d-p-admin-upg-topbar">
        <button className="d-p-admin-upg-back-btn" onClick={handleGoBack}>
          <i className="bi bi-arrow-left-short" />
          Retour
        </button>
        <div className="d-p-admin-upg-breadcrumb">
          <span>Produits</span>
          <i className="bi bi-chevron-right" />
          <span className="d-p-admin-upg-breadcrumb-active">{Designation}</span>
        </div>
      </div>

      {/* Main grid */}
      <div className="d-p-admin-upg-grid">

        {/* Left — image */}
        <div className="d-p-admin-upg-img-col">
          <div className="d-p-admin-upg-img-card">
            <img
              src={urlImage}
              alt={Designation}
              className="d-p-admin-upg-img"
            />
            <span className={`d-p-admin-upg-stock-badge d-p-admin-upg-stock-${stockStatus} d-p-admin-upg-badge-abs`}>
              <span className="d-p-admin-upg-stock-dot" />
              {stockLabel[stockStatus]}
            </span>
          </div>

          {/* Rating card */}
          <div className="d-p-admin-upg-rating-card">
            <div className="d-p-admin-upg-rating">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className={`bi bi-star${s <= 4 ? "-fill" : ""} d-p-admin-upg-star`} />
              ))}
              <span className="d-p-admin-upg-rating-label">4.0 <span>(45 avis)</span></span>
            </div>
          </div>
        </div>

        {/* Middle — details */}
        <div className="d-p-admin-upg-detail-col">

          {/* Header */}
          <div className="d-p-admin-upg-product-header">
            <h1 className="d-p-admin-upg-product-name">
              {Designation}
              {DesignationAr && (
                <span className="d-p-admin-upg-product-name-ar"> · {DesignationAr}</span>
              )}
            </h1>
            {Marque && (
              <span className="d-p-admin-upg-cat-pill">
                <i className="bi bi-grid-fill" /> {Marque}
              </span>
            )}
          </div>

          {/* Price hero */}
          <div className="d-p-admin-upg-price-hero">
            <span className="d-p-admin-upg-price">{PrixNetHT}</span>
            <span className="d-p-admin-upg-price-currency">MAD</span>
            <span className="d-p-admin-upg-price-unit">/ P.U</span>
            {Remise && Number(Remise) > 0 && (
              <span className="d-p-admin-upg-remise-badge">-{Remise}%</span>
            )}
          </div>

          {/* Info grid */}
          <div className="d-p-admin-upg-info-grid">
            <div className="d-p-admin-upg-info-item">
              <i className="bi bi-upc d-p-admin-upg-info-icon" />
              <span className="d-p-admin-upg-info-label">Référence</span>
              <span className="d-p-admin-upg-info-value">{RefArticle}</span>
            </div>
            <div className="d-p-admin-upg-info-item">
              <i className="bi bi-arrow-repeat d-p-admin-upg-info-icon" />
              <span className="d-p-admin-upg-info-label">Substitut</span>
              <span className="d-p-admin-upg-info-value">
                {Array.isArray(LibelleSubstitut) && LibelleSubstitut[0]?.trim()
                  ? LibelleSubstitut.join(", ")
                  : "N/A"}
              </span>
            </div>
            <div className="d-p-admin-upg-info-item">
              <i className="bi bi-boxes d-p-admin-upg-info-icon" />
              <span className="d-p-admin-upg-info-label">Stock</span>
              <span className={`d-p-admin-upg-info-value d-p-admin-upg-stock-text-${stockStatus}`}>
                {actualStock} unités
              </span>
            </div>
            <div className="d-p-admin-upg-info-item">
              <i className="bi bi-percent d-p-admin-upg-info-icon" />
              <span className="d-p-admin-upg-info-label">Remise</span>
              <span className="d-p-admin-upg-info-value">{Remise ?? "0"} %</span>
            </div>
          </div>

          {/* Description — auto generated */}
          <div className="d-p-admin-upg-desc-section">
            <div className="d-p-admin-upg-desc-header">
              <h6 className="d-p-admin-upg-desc-title">Description</h6>
              <span className="d-p-admin-upg-desc-badge">
                <i className="bi bi-stars" /> Réf. {RefArticle}
              </span>
            </div>

            {descLoading ? (
              <div className="d-p-admin-upg-desc-loading">
                <div className="d-p-admin-upg-desc-spinner" />
                <span>Génération de la description automatique… {descLoading}</span>
              </div>
            ) : (
              <p className="d-p-admin-upg-desc-text">
                {autoDescription || Description || "Aucune description disponible."}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  /* ══════════════════════════════════════════════════
     ROOT RENDER
  ══════════════════════════════════════════════════ */
  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"
      />
<NewSideBarAdmin />

      {loading ? (
        <Loader compact={isMobile} />
      ) : isMobile ? (
        <MobileView />
      ) : (
        <DesktopView />
      )}
    </>
  );
};

export default AfficheProduit;